import React from "react";
import { string } from "prop-types";
import Button from "../Button";
import { classes } from "../utils/classes";
import { Col } from "../Grid";
import Heading from "../Heading";
import Paragraph from "../Paragraph";
import Link from "../Link";

const RecommendedResourcesPostItem = ({ className = "", ...props }) => {
	return (
		<Col
			md={6}
			lg={3}
			className={classes("recommended-resources__post-item", className)}
			{...props}
		/>
	);
};

RecommendedResourcesPostItem.propTypes = {
	className: string,
	...Col.propTypes,
};

const Title = ({ className = "", ...props }) => {
	return (
		<Heading
			Tag="h4"
			className={classes("recommended-resources__post-item-title", className)}
			{...props}
		/>
	);
};

Title.propTypes = {
	className: string,
	...Paragraph.propTypes,
};

const ItemLink = ({ href = "/", className = "", ...props }) => {
	return (
		<Link
			href={href}
			className={classes("recommended-resources__post-item-link", className)}
			{...props}
		/>
	);
};

ItemLink.propTypes = {
	className: string,
	href: string,
	...Paragraph.propTypes,
};

const Description = ({ className = "", ...props }) => {
	return (
		<Paragraph
			className={classes("recommended-resources__post-item-description", className)}
			{...props}
		/>
	);
};

Description.propTypes = {
	className: string,
	...Paragraph.propTypes,
};

const ItemButton = ({ ...props }) => {
	return <Button.Link className="mt-5" size="xs" isOutline {...props} />;
};

ItemButton.propTypes = {
	...Button.propTypes,
};

RecommendedResourcesPostItem.Title = Title;
RecommendedResourcesPostItem.Link = ItemLink;
RecommendedResourcesPostItem.Description = Description;
RecommendedResourcesPostItem.Button = ItemButton;

export default RecommendedResourcesPostItem;
